import { ChangeEvent, FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Tab, Tabs, useMediaQuery, useTheme } from '@material-ui/core';
import { LogsTable } from 'components/Tables';
import { useStyles } from './styles';
import TabPanel from 'components/TabPanel';
import { useStore } from 'hooks/useRootStore';
import EmailInvite from 'containers/EmailInvite/EmailInvite';
import ImportInvite from 'containers/ImportInvite';
import SSO from 'containers/OIDC/SSO';
import API from 'containers/API';
import Manager from 'containers/Manager/Manager';
import RiskScanner from 'containers/RiskScanner/RiskScanner';
const Logs: FC = observer(() => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    logsTableStore: { getEndUserLogs, getEndLogs, getAppsLogs, getAttributeLogs },
    userStore: { user },
  } = useStore();
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const [value, setValue] = useState<string>('one');

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };
  useEffect(() => {
    document.title = 'EasyIdentity: Reports: Admin Users';
  }, []);
  if (user?.permission === undefined) {
    return null;
  }
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        {user && user.permission !== 'EndUser' && user.permission !== 'Manager' ? (
          <Tabs
            value={value}
            className={classes.tabs}
            TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
            onChange={handleChange}
            variant={isMobile ? 'scrollable' : 'standard'}
            scrollButtons={isMobile ? 'auto' : 'off'}
          >
            <Tab value='one' wrapped label='Identity Risk' {...a11yProps('one')} className={classes.label} />
            <Tab value='two' wrapped label='Users' {...a11yProps('two')} className={classes.label} />
            <Tab value='three' wrapped label='Managers' {...a11yProps('three')} className={classes.label} />
            <Tab value='four' wrapped label='Apps' {...a11yProps('four')} className={classes.label} />
            <Tab value='five' wrapped label='Attributes' {...a11yProps('five')} className={classes.label} />
            <Tab value='six' wrapped label='Uploads' {...a11yProps('six')} className={classes.label} />
            <Tab value='seven' wrapped label='Emails' {...a11yProps('seven')} className={classes.label} />
            <Tab value='eight' wrapped label='Access Management' {...a11yProps('eight')} className={classes.label} />
            {/* <Tab value='nine' wrapped label='API' {...a11yProps('seven')} className={classes.label} /> */}
          </Tabs>
        ) : (
          user &&
          user.permission === 'Manager' && (
            <Tabs
              value={value}
              className={classes.tabs}
              TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
              onChange={handleChange}
              variant={isMobile ? 'scrollable' : 'standard'}
              scrollButtons={isMobile ? 'auto' : 'off'}
            >
              <Tab
                value='one'
                wrapped
                label={isMobile ? 'Users Log' : 'Users'}
                {...a11yProps('one')}
                className={classes.label}
              />
              <Tab
                value='two'
                wrapped
                label={isMobile ? 'Management' : 'Management'}
                {...a11yProps('two')}
                className={classes.label}
              />
            </Tabs>
          )
        )}

        {user && user?.permission !== 'EndUser' && user.permission !== 'Manager' ? (
          <div className={classes.tabBox}>
            <TabPanel value={value} index='one'>
              <RiskScanner />
            </TabPanel>
            <TabPanel value={value} index='two'>
              <LogsTable headtitle='user' getData={getEndUserLogs} />
            </TabPanel>
            <TabPanel value={value} index='three'>
              <Manager />
            </TabPanel>
            <TabPanel value={value} index='four'>
              <LogsTable headtitle='cloud' getData={getAppsLogs} />
            </TabPanel>
            <TabPanel value={value} index='five'>
              <LogsTable headtitle='cloud' getData={getAttributeLogs} />
            </TabPanel>
            {/* <TabPanel value={value} index='six'>
              <LogsTable headtitle='cloud' getData={ getUserSyncLogs} />
            </TabPanel> */}
            <TabPanel value={value} index='six'>
              <ImportInvite />
            </TabPanel>
            <TabPanel value={value} index='seven'>
              <EmailInvite />
            </TabPanel>
            <TabPanel value={value} index='eight'>
              <SSO />
            </TabPanel>
            {/* <TabPanel value={value} index='nine'>
              <API />
            </TabPanel> */}
          </div>
        ) : user.permission === 'Manager' ? (
          <div className={classes.tabBox}>
            <TabPanel value={value} index='one'>
              <LogsTable
                headtitle='enduser'
                getData={user && user.permission === 'Manager' ? getEndLogs : getEndUserLogs}
              />
            </TabPanel>
            <TabPanel value={value} index='two'>
              <Manager />
            </TabPanel>
          </div>
        ) : (
          <div className={classes.tabBox}>
            <TabPanel value={value} index='one'>
              <LogsTable
                headtitle='enduser'
                getData={
                  user && (user.permission === 'EndUser' || user.permission === 'Manager') ? getEndLogs : getEndUserLogs
                }
              />
            </TabPanel>
          </div>
        )}
      </Paper>
    </Grid>
  );
});

export default Logs;
